<template>
  <div class="ine-form__form-wrapper">
    <form class="ine-form__form" @submit.prevent="validateFields">
      <Title
        header="Reset Your Password"
        tagline="Instructions will be emailed on how to reset your password"
      />
      <Errors :errors="errors.messages" />
      <div class="ine-form__form-group">
        <input
          type="email"
          placeholder="Your Email"
          :class="[
            'ine-form__form-control',
            errors.fields.includes('email') && 'ine-form__form-control--error',
          ]"
          @focus="clearErrors"
          autocomplete="email"
          v-model="email"
        />
      </div>
      <div class="ine-form__actions">
        <SubmitBtn title="Submit" iconName="lock" :isLoading="isLoading" />
      </div>
      <AdditionalLinks :linksShown="['login', 'newAccount', 'plans']" />
    </form>
  </div>
</template>

<script>
import { validateForm, clearFormErrors } from '@/helpers'
import Title from '@/components/forms/elements/Title.vue'
import Errors from '@/components/forms/elements/Errors.vue'
import SubmitBtn from '@/components/forms/elements/SubmitBtn.vue'
import AdditionalLinks from '@/components/forms/elements/AdditionalLinks.vue'

export default {
  name: 'ForgotPasswordForm',
  components: {
    Title,
    Errors,
    SubmitBtn,
    AdditionalLinks,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      errors: clearFormErrors(),
      email: '',
    }
  },
  methods: {
    validateFields() {
      const { email } = this
      const { isValid, errors } = validateForm({
        email: {
          rules: ['presence'],
          value: email,
        },
      })
      this.errors = errors
      if (isValid) {
        this.$emit('submit-form', { email })
      }
    },
    clearErrors() {
      this.errors = clearFormErrors()
    },
  },
}
</script>
